import { Pipe, PipeTransform } from '@angular/core';

import { TableHeader } from 'src/app/table-handling/types';

import { getTableHeaderIdentifier } from '../utils/table-header-identifier';

@Pipe({
  name: 'tableHeaderToCdkTableColumn',
  standalone: true,
})
export class TableHeaderDefSinglePipe implements PipeTransform {
  public transform(header: TableHeader): string {
    return getTableHeaderIdentifier(header);
  }
}
